import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('invoices', { params, ...config }),
  show: (id, params = {}, config = {}) => axios.get(`invoices/${id}`, { params, ...config }),
  activity: (id, params = {}, config = {}) => axios.get(`invoices/${id}/activity`, { params, ...config }),
  activityStore: (id, payload = {}, config = {}) => axios.post(`invoices/${id}/activity`, payload, config),
  preview: (id, params = {}, config = {}) => axios.get(`invoices/${id}/preview`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadZip: (id, params = {}, config = {}) => axios.get(`invoices/${id}/zip`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadPdf: (id, params = {}, config = {}) => axios.get(`invoices/${id}/pdf`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadXml: (id, params = {}, config = {}) => axios.get(`invoices/${id}/xml`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadRequestsLatest: (params = {}, config = {}) => axios.get('invoices/download-requests/latest', { params, ...config }),
  downloadRequestsShow: (requestId, params = {}, config = {}) => axios.get(`invoices/download-requests/${requestId}`, { params, ...config }),
  downloadRequestsStore: (payload = {}, config = {}) => axios.post('invoices/download-requests', payload, config),
  downloadRequestsDirectDownload: (payload = {}, config = {}) => axios.post(
    'invoices/download-requests/direct-download',
    payload,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  downloadRequestsRetryPackage: (requestId, packageId, payload = {}, config = {}) => axios.post(
    `invoices/download-requests/${requestId}/packages/${packageId}/retry`,
    payload,
    config,
  ),
  exportColumns: (config = {}) => axios.get('invoices/exports/columns', config),
  exportFormats: (config = {}) => axios.get('invoices/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('invoices/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`invoices/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`invoices/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('invoices/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  downloadRequestsRegenerate: (requestId, payload = {}, config = {}) => axios.post(
    `invoices/download-requests/${requestId}/regenerate`,
    payload,
    config,
  ),
  downloadRequestsDownloadPackage: (requestId, packageId, params = {}, config = {}) => axios.get(
    `invoices/download-requests/${requestId}/packages/${packageId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  shippingIndex: (id, params = {}, config = {}) => axios.get(`invoices/${id}/shipping`, { params, ...config }),
  shippingStore: (id, payload = {}, config = {}) => axios.post(`invoices/${id}/shipping`, payload, config),
  sendInvoice: (id, payload = {}, config = {}) => axios.post(`send/invoices/${id}`, payload, config),
  documentsIndex: (id, params = {}, config = {}) => axios.get(`invoices/${id}/documents`, { params, ...config }),
  documentsDownload: (id, documentId, params = {}, config = {}) => axios.get(
    `invoices/${id}/documents/${documentId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  documentsStore: (id, payload = {}, config = {}) => axios.post(`invoices/${id}/documents`, payload, config),
  documentsUpdate: (id, documentId, payload = {}, config = {}) => axios.put(`invoices/${id}/documents/${documentId}`, payload, config),
  documentsDelete: (id, documentId, config = {}) => axios.delete(`invoices/${id}/documents/${documentId}`, config),
  documentsDownloadAll: (id, params = {}, config = {}) => axios.get(
    `invoices/${id}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  store: (payload = {}, config = {}) => axios.post('invoices', payload, config),
  metrics: (params = {}, config = {}) => axios.get('invoices/metrics', { params, ...config }),
  additionalSelectors: (params = {}, config = {}) => axios.get('invoices/selectors/additional', { params, ...config }),
  receiverSelectors: (params = {}, config = {}) => axios.get('contributors/selectors', { params, ...config }),
  contributorShow: (contributorId, config = {}) => axios.get(`contributors/${contributorId}`, config),
  serialSelectors: (params = {}, config = {}) => axios.get('invoices/serials/selectors', { params, ...config }),
  productSelectors: (params = {}, config = {}) => axios.get('invoices/products/selectors', { params, ...config }),
};
